var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticStyle: { display: "unset" } },
    [
      _c(
        "b-btn",
        {
          attrs: { size: "sm", variant: "success" },
          on: {
            click: function($event) {
              return _vm.onSelectStaff()
            }
          }
        },
        [
          _c("font-awesome-icon", { attrs: { icon: ["fas", "plus"] } }),
          _vm._v("\n    Выбрать сотрудников\n  ")
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "b-modal",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.show,
              expression: "show"
            }
          ],
          ref: "modalStaffsSelect",
          attrs: {
            id: "modal-staff-select",
            "content-class": "modal-fullscreen",
            "body-class": "modal-body-fullscreen",
            size: "xl",
            title: "Персонал",
            "ok-only": false,
            "no-fade": true,
            "ok-title": "Выбрать",
            "cancel-title": "Отменить",
            "button-size": "sm",
            "no-close-on-esc": "",
            "no-close-on-backdrop": "",
            scrollable: ""
          },
          on: { ok: _vm.onOk, cancel: _vm.onCancel, close: _vm.onCancel }
        },
        [
          _c(
            "b-navbar",
            { staticClass: "mb-1", attrs: { id: "" } },
            [
              _c(
                "b-navbar-nav",
                [
                  _c(
                    "b-form",
                    {
                      attrs: { inline: "" },
                      on: {
                        submit: function($event) {
                          $event.preventDefault()
                          return _vm.onSearch()
                        }
                      }
                    },
                    [
                      _c("b-form-input", {
                        staticClass: "mr-2",
                        attrs: {
                          size: "sm",
                          debounce: "500",
                          placeholder: "Поиск"
                        },
                        model: {
                          value: _vm.filters.query,
                          callback: function($$v) {
                            _vm.$set(_vm.filters, "query", $$v)
                          },
                          expression: "filters.query"
                        }
                      }),
                      _vm._v(" "),
                      _c("organization-select", {
                        ref: "organization_select",
                        staticClass: "mr-2",
                        attrs: { id: "input-org-select" },
                        on: { onSelect: _vm.onSelectOrg }
                      }),
                      _vm._v(" "),
                      _c("department-select", {
                        ref: "department_select",
                        staticClass: "mr-2",
                        attrs: { id: "input-department-select" },
                        on: { onSelect: _vm.onSelectDepartment }
                      }),
                      _vm._v(" "),
                      _c("job-title-select", {
                        ref: "job_title_select",
                        staticClass: "mr-2",
                        attrs: { id: "input-job-title-select" },
                        on: { onSelect: _vm.onSelectJobTitle }
                      }),
                      _vm._v(" "),
                      _c(
                        "b-button",
                        {
                          staticClass: "mr-1",
                          attrs: { size: "sm", variant: "outline-success" },
                          on: {
                            click: function($event) {
                              $event.preventDefault()
                              return _vm.onSearch()
                            }
                          }
                        },
                        [_vm._v("\n            Применить\n          ")]
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          ),
          _vm._v(" "),
          _c("b-table", {
            ref: "staffs",
            staticClass: "mb-0 text-small",
            attrs: {
              id: "staffs",
              "select-mode": "multi",
              selectedVariant: "success",
              striped: "",
              small: "",
              responsive: "",
              "show-empty": "",
              "empty-text": _vm.$t("message.common.emptyTable"),
              busy: _vm.isBusy,
              items: _vm.items,
              fields: _vm.fields,
              "no-provider-filtering": "",
              "no-provider-paging": "",
              "no-provider-sorting": "",
              "tbody-tr-class": _vm.tbodyRowClass,
              "sticky-header": "",
              "head-variant": "light"
            },
            on: { "row-clicked": _vm.onRowClicked },
            scopedSlots: _vm._u([
              {
                key: "table-busy",
                fn: function() {
                  return [
                    _c(
                      "div",
                      { staticClass: "text-center text-success my-2" },
                      [
                        _c("b-spinner", { staticClass: "align-middle" }),
                        _vm._v(" "),
                        _c("strong", [_vm._v("Загрузка")])
                      ],
                      1
                    )
                  ]
                },
                proxy: true
              },
              {
                key: "head(selected)",
                fn: function(row) {
                  return [
                    _c("b-form-checkbox", {
                      staticClass: "mx-1",
                      attrs: {
                        indeterminate: _vm.indeterminate,
                        disabled: _vm.allSelectDisabled,
                        size: "md"
                      },
                      on: { change: _vm.selectAllRows },
                      model: {
                        value: _vm.allSelected,
                        callback: function($$v) {
                          _vm.allSelected = $$v
                        },
                        expression: "allSelected"
                      }
                    })
                  ]
                }
              },
              {
                key: "cell(selected)",
                fn: function(row) {
                  return [
                    row.item.selected
                      ? [
                          _c("span", { attrs: { "aria-hidden": "true" } }, [
                            _vm._v("✓")
                          ]),
                          _vm._v(" "),
                          _c("span", { staticClass: "sr-only" }, [
                            _vm._v("Выбрана")
                          ])
                        ]
                      : [
                          _c("span", [_vm._v(" ")]),
                          _vm._v(" "),
                          _c("span", { staticClass: "sr-only" }, [
                            _vm._v("Не выбрана")
                          ])
                        ]
                  ]
                }
              },
              {
                key: "cell(name)",
                fn: function(row) {
                  return [
                    _vm._v(
                      "\n        " +
                        _vm._s(
                          _vm.getShortName(
                            row.item.surname,
                            row.item.name,
                            row.item.patronymic
                          )
                        ) +
                        "\n      "
                    )
                  ]
                }
              },
              {
                key: "cell(migration_entry_date)",
                fn: function(row) {
                  return [
                    _vm._v(
                      "\n        " +
                        _vm._s(
                          _vm.formatTableDate(row.item.migration_entry_date)
                        ) +
                        "\n      "
                    )
                  ]
                }
              },
              {
                key: "cell(contract_add_date)",
                fn: function(row) {
                  return [
                    _vm._v(
                      "\n        " +
                        _vm._s(
                          _vm.formatTableDate(row.item.contract_add_date)
                        ) +
                        "\n      "
                    )
                  ]
                }
              },
              {
                key: "cell(patent_issue_date)",
                fn: function(row) {
                  return [
                    _vm._v(
                      "\n        " +
                        _vm._s(
                          _vm.formatTableDate(row.item.patent_issue_date)
                        ) +
                        "\n      "
                    )
                  ]
                }
              },
              {
                key: "cell(patent_expiration)",
                fn: function(row) {
                  return [
                    _vm._v(
                      "\n        " +
                        _vm._s(
                          _vm.formatTableDate(row.item.patent_expiration)
                        ) +
                        "\n      "
                    )
                  ]
                }
              },
              {
                key: "cell(salary)",
                fn: function(row) {
                  return [
                    _vm._v(
                      "\n        " +
                        _vm._s(_vm.priceFormat(row.item.salary)) +
                        "\n      "
                    )
                  ]
                }
              },
              {
                key: "cell(contract_salary)",
                fn: function(row) {
                  return [
                    _vm._v(
                      "\n        " +
                        _vm._s(_vm.priceFormat(row.item.contract_salary)) +
                        "\n      "
                    )
                  ]
                }
              }
            ])
          }),
          _vm._v(" "),
          _c("pagination-footer", {
            attrs: { "total-rows": _vm.totalRows, "per-page": _vm.perPage },
            on: {
              "update:perPage": function($event) {
                _vm.perPage = $event
              },
              "update:per-page": function($event) {
                _vm.perPage = $event
              },
              "page-click": _vm.onPagination,
              "per-page-change": _vm.onPerPageChange
            }
          })
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-0d9cf434", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0d9cf434","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Staff/StaffMultiSelect.vue
// module id = null
// module chunks = 